/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { PianoModal } from './customBlocks/pianoModal';

Blockly.Blocks.IACO_buttons = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/icon.png`, 32, 19))
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_SPACE);
    this.appendStatementInput('BUTN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_BUTTON_M);
    this.appendStatementInput('BUTN2')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_BUTTON_S);
    this.appendStatementInput('BUTN3')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_BUTTON_L);
    this.appendStatementInput('BUTN4')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_BUTTON_R);
    this.appendStatementInput('BUTNA')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_BUTTON_A);
    this.appendStatementInput('BUTNB')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_IACO_BUTTONS_BUTTON_B);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_IACO_BUTTONS_TOOLTIP);
  },
};

// La variable global IACOangulo la setea IACO_buttons cuando el mensaje OMNP trae un ángulo.
Blockly.Blocks.IACO_angle = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_IACO_GET_ANGLE);
    this.setOutput(true);
  },
};

// Sin el dummy input de 90 espacios del legacy: el preview del piano es el
// propio campo y ya declara su tamaño.
Blockly.Blocks.IACO_piezo_buzzer = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO);
    this.appendDummyInput()
      .appendField(new PianoModal({
        basePitch: 165, octave: 3, duration: 1000, pin: '12',
      }, undefined, {}), 'PIANO');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_PIN);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
};

Blockly.Blocks.IACO_piezo_buzzer_variable = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight));
    this.appendValueInput('VAR')
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO)
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TONE_LC);
    this.appendValueInput('DURATION')
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_DURATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_PIN);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.IACO_piezo_buzzerno = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight));
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZERNO);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.IACO_motor = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_IACO_MOTOR_DOUBLE_FORWARD_SHORT || 'Avanzar', '3'],
        [Blockly.Msg.LANG_IACO_MOTOR_DOUBLE_BACKWARD_SHORT || 'Retroceder', '4'],
        [Blockly.Msg.LANG_IACO_MOTOR_DOUBLE_TURN_RIGHT_SHORT || 'Mover a la derecha', '5'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT_SHORT || 'Girar a la derecha', '6'],
        [Blockly.Msg.LANG_IACO_MOTOR_DOUBLE_TURN_LEFT_SHORT || 'Mover a la izquierda', '7'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT_SHORT || 'Girar a la izquierda', '8'],
        [Blockly.Msg.LANG_IACO_MOTOR_DOUBLE_BRAKE_SHORT || 'Frenar', '9'],
      ]), 'DIR');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_TOOLTIP);
  },
  component: 'motor',
};

Blockly.Blocks.IACO_motor_degrees = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_IACO_MOTOR_DOUBLE_DEGREES);
    this.appendValueInput('angulo')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  component: 'motor',
};
